import React from 'react';
import HomeVid from '../components/Home/HomeVid';
import WhoWeAre from './WhoWeAre';
import EvalueRequest from '../components/Home/EvalueRequest';
import AsSeenOn from '../components/Home/AsSeenOn';

function Home() {
  return (
    <div>
      <HomeVid />
      <EvalueRequest />
      <WhoWeAre />  
      <AsSeenOn />
    </div>
  );
}

export default Home;

